import ApiCalls from "../../api";
import { ContactStoreActions } from "../../redux/contacts-store";
import { store } from "../../redux/store";

const ContactHelper = {
  createNewContact: async ({ name, phone, email }) => {
    const contactData = {
      of: "unknown",
      name,
    };
    
    if (phone) {
      contactData.platforms = [
        {
          referenceId: `whatsapp:${phone}`,
          on: "whatsapp",
        },
      ];
      contactData.phone = phone;
    }
    
    if (email) {
      contactData.email = email;
    }
    
    const response = await ApiCalls.contact.private.createContact(contactData);
    return {
      contactId: response?.data?.data?._id || null,
    };
  },
  fetchAllContacts: async () => {
    const {data} = await ApiCalls.contact.private.getContacts();
    if (data?.data?.docs) {
      store.dispatch(ContactStoreActions.setContacts(data.data.docs));
    }

  },
  updateContact: async (contactId, updates) => {
    const response = await ApiCalls.contact.private.updateContact(contactId, updates);
    return response?.data?.data || null;
  },
  deleteContact: async (contactId) => {
    const response = await ApiCalls.contact.private.deleteContact(contactId);
    return response?.data?.data || null;
  },
  checkContactExists: async ({ email, phone }) => {
    const response = await ApiCalls.contact.private.checkIfContactExists({ email, phone });
    return response?.data?.data || null;
  },
};

export default ContactHelper;
